import React, { useEffect, useState } from 'react';
import {
  Typography,
  Box,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Stack,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Pagination,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { filterArticles, deleteArticle } from '../../../models/Article';

export default function ManageArticles({ categoryId }) {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(12);
  const [searchTitle, setSearchTitle] = useState('');

  const navigate = useNavigate();
  const isChienKi = categoryId === 1;
  const categoryName = isChienKi ? 'Chiến Ký' : 'Lược Sử';

  const fetchArticles = async () => {
    try {
      setLoading(true);
      const res = await filterArticles({
        category_id: categoryId,
        page,
        limit,
        title: searchTitle || undefined,
      });
      if (res.data) {
        setArticles(res.data);
        setTotal(res.total || 0);
      }
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchArticles();
  }, [categoryId, page, limit, searchTitle]);

  const handleDelete = async (id) => {
    if (window.confirm('Bạn có chắc chắn muốn xóa bài viết này không?')) {
      try {
        await deleteArticle(id);
        fetchArticles();
      } catch (err) {
        alert('Xóa thất bại');
      }
    }
  };

  const handleSearchChange = (e) => {
    setSearchTitle(e.target.value);
    setPage(1);
  };

  return (
    <Box>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Quản lý {categoryName}
      </Typography>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        mb={3}
      >
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/dashboard/add')}
          sx={{ whiteSpace: 'nowrap' }}
        >
          Thêm bài viết
        </Button>

        <TextField
          label="Tìm kiếm theo tiêu đề"
          value={searchTitle}
          onChange={handleSearchChange}
          size="small"
          sx={{ flexGrow: 1 }}
        />

        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>Số bài/trang</InputLabel>
          <Select
            value={limit}
            label="Số bài/trang"
            onChange={(e) => setLimit(Number(e.target.value))}
          >
            {[5, 10, 12, 20, 50].map((num) => (
              <MenuItem key={num} value={num}>
                {num}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>

      {loading ? (
        <Typography>Đang tải dữ liệu...</Typography>
      ) : (
        <>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Tiêu đề</TableCell>
                <TableCell>Timeline</TableCell>
                <TableCell>Ngày tạo</TableCell>
                <TableCell align="center">Thao tác</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {articles.map((article) => (
                <TableRow key={article.id}>
                  <TableCell>{article.title}</TableCell>
                  <TableCell>{article.timeline_name || 'Không có'}</TableCell>
                  <TableCell>
                    {new Date(article.created_at).toLocaleDateString('vi-VN')}
                  </TableCell>
                  <TableCell align="center">
                    <Stack direction="row" spacing={1} justifyContent="center">
                      <IconButton
                        color="primary"
                        onClick={() => alert(`TODO: Sửa bài viết ID: ${article.id}`)}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton color="error" onClick={() => handleDelete(article.id)}>
                        <DeleteIcon />
                      </IconButton>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {/* Pagination */}
          <Stack spacing={2} mt={2} alignItems="center">
            <Pagination
              count={Math.ceil(total / limit)}
              page={page}
              onChange={(e, value) => setPage(value)}
              color="primary"
            />
          </Stack>
        </>
      )}
    </Box>
  );
}
